module.exports = __webpack_public_path__ + "static/media/icon-live-ic-cancel.2cc51342.svg";